import Item from '../common/item'
import Api from '../api'

const state = Object.assign({}, Item.state)
state.endpoint = 'file'

const actions = Object.assign({}, Item.actions)
actions.softDelete = function ({commit, state}, id) {
  return new Promise((resolve, reject) => {
    Api.put(state.endpoint + '/' + id + '/delete', {}, response => {
      resolve(response)
    }, response => {
      reject(response)
    })
  })
}

actions.restore = function ({ commit, state }, id) {
  return new Promise((resolve, reject) => {
    Api.delete(state.endpoint + '/' + id + '/delete', {}, response => {
      resolve(response)
    }, response => {
      reject(response)
    })
  })
}

actions.realDelete = function ({commit, state}, id) {
  return new Promise((resolve, reject) => {
    Api.delete(state.endpoint + '/' + id, {}, response => {
      resolve(response)
    }, response => {
      reject(response)
    })
  })
}

actions.favorite = function ({state}, id) {
  return new Promise((resolve, reject) => {
    Api.post(state.endpoint + '/' + id + '/favorite', {}, response => {
      resolve(response)
    }, response => {
      reject(response)
    })
  })
}

actions.unfavorite = function ({state}, id) {
  return new Promise((resolve, reject) => {
    Api.delete(state.endpoint + '/' + id + '/favorite', {}, response => {
      resolve(response)
    }, response => {
      reject(response)
    })
  })
}

actions.viewShared = function ({commit, state}, id) {
  return new Promise((resolve, reject) => {
    Api.get(state.endpoint + '/' + id + '/shared', {}, response => {
      commit('loadRelated', response.body)
      resolve(response)
    }, response => {
      reject(response)
    })
  })
}

export default {
  namespaced: true,
  state,
  getters: {
    ...Item.getters,
    currentFileId: state => {
      if (state.record && state.record.id_file) {
        return state.record.id_file
      } else {
        return null
      }
    },
    ancestors: state => {
      if (state.record && state.record.ancestors) {
        return state.record.ancestors
      } else {
        return null
      }
    },
    currentType: state => {
      if (state.record && state.record.type) {
        return state.record.type
      } else {
        return null
      }
    }
  },
  mutations: {
    ...Item.mutations,
    loadRelated (state, record) {
      state.related = record
    }
  },
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/file.js